<pr-tag-list [tags]="contactTags$ | async" (tagAdded)="addTag($event)" />
